import React from 'react';
import classnames from 'classnames';

import { EMAIL_PREFERENCES_URL } from '../../constants/apiUrls/apiUrls';
import callApi from '../../utils/callApi';
import './css/EmailPreferences.css';
import { AccountTabs } from '../ManageAccount/AccountTabs';
import { isGuestOrFreemiumUser } from '../../utils/getUserDetails';
import TransparentLoader from '../../components/Loaders/TransparentLoader';
import Alert from '../../components/generalComponents/Alert';


class EmailPrefPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAlertVisible: false,
      content: '',
      preferences: {
        recieve: true,
        newsletter: true,
        offers: true,
        partnerOffers: true,
        announcements: true,
        notifyAnchorOnline: true,
      },
    };
  }

  componentDidMount() {
    const { user } = this.props;

    if (user.user && user.user.account) {
      this.setState({ preferences: user.user.account.preferences });
    }
  }

  showAlert = (content) => {
    this.setState({
      isAlertVisible: true,
      content,
    });
  };

  hideAlert = () => {
    this.setState({
      isAlertVisible: false,
      content: '',
    });
  };

  handleChange = (name) => (e) => {
    this.setState({
      preferences: {
        ...this.state.preferences,
        [name]: e.target.checked,
      },
      isAlertVisible: false,
    });
  };

  handleSubmit = (e) => {
    const {
      recieve,
      newsletter,
      offers,
      partnerOffers,
      announcements,
      notifyAnchorOnline,
    } = this.state.preferences;
    const data = {
      recieve,
      newsletter,
      offers,
      partnerOffers,
      announcements,
      notifyAnchorOnline,
    };
    e.preventDefault();
    this.setState({ isLoading: true });
    callApi(EMAIL_PREFERENCES_URL, 'PATCH', false, data, true, true).
      then((res) => {
        if (res.status === 200) {
          this.setState({
            isLoading: false,
            isAlertVisible: true,
            content: 'Settings are saved',
          });
        }
      }).
      catch(() => this.setState({ isLoading: false }));
  };

  render() {
    const {
      recieve,
      newsletter,
      offers,
      partnerOffers,
      announcements,
      notifyAnchorOnline,
    } = this.state.preferences;
    const { isLoading, isAlertVisible, content } = this.state;
    const { user } = this.props;
    const isAnchor = !!user.user.account.anchor;

    return (
      <div
        className={classnames('content', 'flex-1', { 'freemium-user-content': isGuestOrFreemiumUser(user) }
        )}
      >
        {isLoading && <TransparentLoader />}
        {isAlertVisible && (
          <Alert onClose={this.hideAlert}>{content}</Alert>
        )}
        <div className="container">
          <AccountTabs active="/account/email_preferences" />
          <div className="section" style={{ margin: '30px 0' }}>
            <div className="container" id="email_preferences">
              <h3>My Email Preferences</h3>
              <form
                acceptCharset="UTF-8"
                className="formtastic form-horizontal"
                onSubmit={this.handleSubmit}
              >
                <input
                  defaultValue="✓"
                  name="utf8"
                  type="hidden"
                />
                <input
                  defaultValue="ZUL9BtVLsm3nOBLysN3lOSGtyHRvKCdd6XhOWl34lkJhtqo5jUlvDS4Fz30h4y26bHJlaN+cTcTbClq7jrI9WQ=="
                  name="authenticity_token"
                  type="hidden"
                />
                <div
                  className="input form-group"
                  style={{ margin: '10px 0' }}
                >
                  <label
                    className="control-label"
                    htmlFor="recieve"
                  >
                    Receive emails
                  </label>
                  <div className="form-inline">
                    <input
                      checked={recieve}
                      className="form-control"
                      id="recieve"
                      name="recieve"
                      type="checkbox"
                      onChange={this.handleChange(
                        'recieve'
                      )}
                    />
                    <span className="help-inline">
                      If you elect not to receive emails
                      from Naked News, we may still send
                      you transactional emails (such as
                      receipts, lost password requests,
                      and customer service emails) as
                      necessary.
                    </span>
                  </div>
                </div>
                <fieldset id="enrollments">
                  <legend>
                    Select the types of emails that you
                    would like to receive
                  </legend>
                  <div
                    className="input form-group"
                    style={{ margin: '10px 0' }}
                  >
                    <label
                      className="control-label"
                      htmlFor="campaign_category_ids_4"
                    >
                      Newsletter
                    </label>
                    <div className="form-inline">
                      <input
                        checked={newsletter}
                        className="form-control enrollment"
                        id="campaign_category_ids_4"
                        name="newsletter"
                        type="checkbox"
                        onChange={this.handleChange(
                          'newsletter'
                        )}
                      />
                      <span className="help-inline">
                        The latest news and updates from
                        Naked News.
                      </span>
                    </div>
                  </div>
                  <div
                    className="input form-group"
                    style={{ margin: '10px 0' }}
                  >
                    <label
                      className="control-label"
                      htmlFor="campaign_category_ids_6"
                    >
                      Offers
                    </label>
                    <div className="form-inline">
                      <input
                        checked={offers}
                        className="form-control enrollment"
                        id="campaign_category_ids_6"
                        name="offers"
                        type="checkbox"
                        onChange={this.handleChange(
                          'offers'
                        )}
                      />
                      <span className="help-inline">
                        Special offers and deals for
                        Naked News.
                      </span>
                    </div>
                  </div>
                  <div
                    className="input form-group"
                    style={{ margin: '10px 0' }}
                  >
                    <label
                      className="control-label"
                      htmlFor="campaign_category_ids_7"
                    >
                      Partner Offers
                    </label>
                    <div className="form-inline">
                      <input
                        checked={partnerOffers}
                        className="form-control enrollment"
                        id="campaign_category_ids_7"
                        name="partnerOffers"
                        type="checkbox"
                        onChange={this.handleChange(
                          'partnerOffers'
                        )}
                      />
                      <span className="help-inline">
                        Special offers for our partner&apos;s
                        sites.
                      </span>
                    </div>
                  </div>
                  <div
                    className="input form-group"
                    style={{ margin: '10px 0' }}
                  >
                    <label
                      className="control-label"
                      htmlFor="campaign_category_ids_10"
                    >
                      Announcements
                    </label>
                    <div className="form-inline">
                      <input
                        checked={announcements}
                        className="form-control enrollment"
                        id="campaign_category_ids_10"
                        name="announcements"
                        type="checkbox"
                        onChange={this.handleChange(
                          'announcements'
                        )}
                      />
                      <span className="help-inline">
                        Announcements about site feature
                        and policy updates.
                      </span>
                    </div>
                  </div>
                  {!isAnchor &&
                  <div
                    className="input form-group"
                    style={{ margin: '10px 0' }}
                  >
                    <label
                      className="control-label"
                      htmlFor="campaign_category_ids_11"
                    >
                      Fan Zone
                    </label>
                    <div className="form-inline">
                      <input
                        checked={notifyAnchorOnline}
                        className="form-control enrollment"
                        id="campaign_category_ids_11"
                        name="notifyAnchorOnline"
                        type="checkbox"
                        onChange={this.handleChange(
                          'notifyAnchorOnline'
                        )}
                      />
                      <span className="help-inline">
                        Notifications from favorite anchors.
                      </span>
                    </div>
                  </div>}
                </fieldset>
                <p id="accept_privacy_policy">
                  By choosing to receive emails from Naked
                  News, you are agreeing to the terms of our{' '}
                  <a href="/privacy_policy">Privacy Policy</a>
                  .
                </p>
                <button
                  className="btn btn-primary"
                  type="submit"
                >
                  Update Preferences
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EmailPrefPage;
